export const advancedDataLinks = {
    advancedData: () => '/advanced-data'
};
